import axios from '../core/axios';

import { ApiConstants } from './api-constants';
export class LeadsService {
  static initLead = async () => {
    return await (
      await axios.post(ApiConstants.LEADS_API.INIT_LEAD.URL())
    ).data;
  };
  static createLead = async (data: {
    name: string;
    title?: string;
    agency?: string;
    sport?: string;
    status?: string;
    email?: string;
    phone?: string;
    leadTypeId?: string;
    leadId?: string;
  }) => {
    return await (
      await axios.post(ApiConstants.LEADS_API.CREATE_LEAD.URL(), data)
    ).data;
  };
  static getAllLeads = async (
    page: number,
    limit: number,
    mine: boolean = false,
    search: string = '',
    sport?: string,
    sort?: string,
    lastModifiedFrom?: string,
    lastModifiedTo?: string,
    lastModifiedDate?: string,
    assignedTo?: string,
    agencyName?: string,
  ) => {
    return await (
      await axios.get(
        ApiConstants.LEADS_API.GET_ALL_LEADS.URL(page, limit, mine, search, sport, sort) +
          ApiConstants.LEADS_API.GET_ALL_LEADS.QUERY_PARAMS({
            lastModifiedFrom,
            lastModifiedTo,
            lastModifiedDate,
            assignedTo,
            agencyName,
          }),
      )
    ).data;
  };

  static getLeadById = async (leadId: string) => {
    return await (
      await axios.get(ApiConstants.LEADS_API.GET_LEAD_BY_ID.URL(leadId))
    ).data;
  };

  static updateLead = async (leadId: string, data: any) => {
    return await (
      await axios.patch(ApiConstants.LEADS_API.EDIT_LEAD.URL(leadId), data)
    ).data;
  };

  static deleteLead = async (leadId: string) => {
    return await (
      await axios.delete(ApiConstants.LEADS_API.DELETE_LEAD.URL(leadId))
    ).data;
  };

  static getAgencyDropdowns = async () => {
    return await (
      await axios.get(ApiConstants.LEADS_API.AGENCY_DROPDOWN.URL())
    ).data;
  };
  static getAssigneeDropdowns = async () => {
    return await (
      await axios.get(ApiConstants.LEADS_API.ASSIGNEE_DROPDOWN.URL())
    ).data;
  };
  static getLeadTypes = async () => {
    return await (
      await axios.get(ApiConstants.LEADS_API.GET_LEAD_TYPES.URL())
    ).data;
  };

  static getLeadTypeDropdowns = async (leadTypeId: string) => {
    return await (
      await axios.get(ApiConstants.LEADS_API.GET_LEADS_DROPDOWNS.URL(leadTypeId))
    ).data;
  };
  static getDemographicProData = async (id: string) => {
    return await (
      await axios.get(ApiConstants.LEADS_API.DEMOGRAPHIC_PRO_DATA.URL(id))
    ).data;
  };
  static async getLeadPresignedUrl(fileName: string, type: string, size: string, leadId: string) {
    const response = await axios.get(
      ApiConstants.LEADS_API.GET_PRESIGNED_URL.URL(fileName, type, size, leadId),
    );
    return response?.data || response;
  }
  static async convertLeadToClient(
    leadId: string,
    payload: { name: string; salutation?: string; recordType?: string; ownerName?: string },
  ) {
    const response = await axios.post(ApiConstants.LEADS_API.CONVERT_TO_CLIENT.URL(leadId), {
      ...payload,
    });
    return response?.data || response;
  }
  static syncCaptiv8Lead = async (captiv8Id: string) => {
    if (!captiv8Id) return null;
    return await axios.get(ApiConstants.LEADS_API.CAPTIV8_LEADS.URL(captiv8Id));
  };
  static getAllLeadFiles = async (leadId: string) => {
    return await axios.get(ApiConstants.LEADS_API.GET_ALL_LEAD_FILES.URL(leadId));
  };
  static getAnalysis = async (payload: any) => {
    return await axios.post(ApiConstants.LEADS_API.GET_ANALYSIS.URL(), payload);
  };
  static getLeadCredits = async () => {
    return await axios.get(ApiConstants.LEADS_API.LEAD_CREDITS.URL());
  };
}
